<template>
    <div>
        <el-button
            size="mini"
            :disabled="readonly || disabled"
            @click="selectOrg"
            icon="el-icon-plus"
            type="primary"
            round
        >{{ placeholder }}</el-button>
        <org-items
            :value="value"
            :closable="!disabled"
            @remove="$emit('input', value)"
        />
        <org-picker
            title="请选择"
            ref="orgPicker"
            :selected="value"
            type="user"
            @ok="selected"
            :multiple="multiple"
            v-bind="$attrs"
        />
    </div>
</template>
  
<script>
import OrgPicker from "./OrgPicker.vue";
import OrgItems from "./OrgItems.vue";
  
export default {
    name: "OrgUserPicker",
    components: { OrgPicker, OrgItems },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: "请选择"
        },
        multiple: {
            type: Boolean,
            default: true
        },
        value: {
            type: Array,
            default: () => []
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showOrgSelect: false
        }
    },
    methods: {
        selectOrg() {
            this.$refs.orgPicker.show()
        },
        selected(select) {
            const len = select.length
            if (len > this.$attrs.max) {
             select.splice(len - 1, 1)
            }
            this.$emit("input", [...select])
        }
    }
}
</script>
  
<style lang="less" scoped>
    .desc {
        font-size: small;
        color: #8c8c8c;
    }
    .org-item {
        margin: 5px;
    }
</style>
  